import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from '../service/language.service';


@Component({
    selector: 'app-painting-details',
    templateUrl: './painting-details.component.html',
    styleUrls: ['./painting-details.component.scss'],
    standalone: false
})
export class PaintingDetailsComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  constructor(private translate: TranslateService, private _language: LanguageService ) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }

  ngOnInit(): void {
  }

}
